<lf-modal *ngIf="doShowLoadingModal"
          [(show)]="doShowLoadingModal"
          [closable]="false"
          [type]="loadingModalComponent"
          class="loading-modal"></lf-modal>

<div class="make-payment-box">
    <div class="page-header w-100 d-flex justify-content-between">
        <h1>Make a Payment</h1>
    </div>

    <div class="card">
        <div class="card-header ">
            <div class="w-100 justify-content-between d-flex">
                <h2 *ngIf="jwt" class="font-weight-normal">
                    <span class="title-text">Name: </span>
                    <b *ngIf="!hasOrgCharges">{{jwt.familyName}}, {{jwt.givenNames}}</b>

                    <span class="title-text">&ensp;|&ensp;Organization: </span>
                    <b>{{jwt.orgName}}</b>

                    <span class="title-text">&ensp;|&ensp;Amount Due: </span>
                    <b *ngIf="!isLoadingCharges"
                       [innerHTML]="accountBalance | legfiCurrency:'USD':'symbol':'.2':true"></b>
                </h2>

                <div class="font-weight-normal text-right custom-hide" style="margin: 15px 25px;">
                    <a
                        *ngIf="!hasOrgCharges" [routerLink]="[userAccountRoute]">
                        View Account History <i class="fa fa-angle-right "></i>
                    </a>
                </div>
            </div>
        </div>
        <div *ngIf="!isLoadingCharges && !(charges && charges.length)" class="card-body">
            <div class="no-charges">
                <em>There are no outstanding charges on your account.</em>
            </div>
        </div>

        <div *ngIf="isLoadingCharges || !isLoadingCharges && (charges && charges.length)" class="scrollable card-body p-0">
            <table class="table charges-table">
                <thead>
                <tr>
                    <th>
                        <div class="checkbox-cell">
                            <label>
                                <input (change)="selectCharges($event.target.checked);" checked class="custom-checkbox"
                                       type="checkbox"/>
                                <span></span>
                            </label>
                        </div>
                    </th>
                    <th>Status</th>
                    <th>Charge</th>
                    <th>Unit</th>
                    <th>Active On</th>
                    <th>Due Date</th>
                    <th>Payment Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="isLoadingCharges">
                    <td colspan="7">
                        <div class="animated-background"></div>
                    </td>
                </tr>
                <tr *ngIf="isLoadingCharges">
                    <td colspan="7">
                        <div class="animated-background"></div>
                    </td>
                </tr>
                <tr *ngIf="isLoadingCharges">
                    <td colspan="7">
                        <div class="animated-background"></div>
                    </td>
                </tr>
                <!--suppress HtmlUnknownAttribute -->
                <ng-template [ngForOf]="charges" let-charge ngFor>
                    <tr *ngIf=" charge " [class.borderless]="feeParentIsPresent(charge)"
                        [class.checked]="charge.checked"
                        [class.late-fee]="charge.category && charge.category.internalUse === 1">
                        <td class="custom-hide" data-label="Select Payment">
                            <div class="checkbox-cell">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <label class="d-none d-md-inline">
                                    <input (change)="modifyRowCheckedStatus(charge, !charge.checked);" (click)="$event.stopPropagation();" [checked]="charge.checked"
                                           class="custom-checkbox"
                                           type="checkbox"/>
                                    <span></span>
                                </label>
                            </div>
                        </td>
                        <td class="charge-status-container" data-label="Status">
                            <div [class.current]="charge.status === 'current'"
                                 [class.deleted]="charge.status === 'deleted'"
                                 [class.future]="charge.status === 'future'"
                                 [class.overdue]="charge.status === 'overdue'"
                                 [class.paid]="charge.status === 'paid'"
                                 [class.partial]="charge.status === 'partial'"
                                 class="charge-status">
                                <ng-container *ngIf="charge.category && charge.category.internalUse === 1">
                                    Late Fee
                                    <hr/>
                                </ng-container>
                                <span *ngIf="charge.status === 'future'">Future</span>
                                <span *ngIf="charge.status === 'current'">Current</span>
                                <span *ngIf="charge.status === 'overdue'">Past Due</span>
                                <span *ngIf="charge.status === 'paid'">Paid</span>
                                <span *ngIf="charge.status === 'partial'">Partial</span>
                                <span *ngIf="charge.status === 'deleted'">Deleted</span>
                            </div>
                        </td>
                        <td class="description-container" data-label="Charge">
                            <label class="d-md-none d-inline float-right">
                                <input #checkRow (change)="modifyRowCheckedStatus(charge, checkRow.checked);" (click)="$event.stopPropagation();" [checked]="charge.checked"
                                       class="custom-checkbox"
                                       type="checkbox"/>
                                <span></span>
                            </label>

                            <div class="mb-1">
                                <strong>{{charge.title}}</strong>
                            </div>
                            <div [innerHTML]="charge.description | nl2br"></div>

                            <div *ngIf="charge.earlyBefore && moment() < charge.earlyBefore" class="discount">
                                <span>
                                    Early Payment Discount Applied: –{{charge.earlyDiscount |
                                    legfiCurrency:'USD':'symbol':'.2'}}<br/>
                                    Ends {{charge.earlyBefore | legfiDate:'MM/DD/YYYY'}}
                                </span>
                            </div>
                            <div *ngIf="charge.lateAfter && moment() <= charge.lateAfter"
                                 class="late-fee">
                                <span>
                                    Pay by {{moment(charge.lateAfter).add(1, 'day').subtract(1, 'second') |
                                    legfiDate:'MM/DD/YYYY'}}
                                    to avoid a {{charge.lateFee | legfiCurrency:'USD':'symbol':'.2'}} late fee.
                                </span>
                            </div>

                            <div *ngIf="charge.lateAfter && moment() > moment(charge.lateAfter).add(1, 'day').subtract(1, 'second')"
                                 class="late-fee">
                                <span>
                                    Late Fee Applied: {{charge.lateFee | legfiCurrency:'USD':'symbol':'.2'}}
                                </span>
                            </div>

                            <div *ngIf="charge.lateFees"
                                 class="late-fee">
                                <ng-template [ngForOf]="charge.lateFees" let-fee ngFor>
										<span *ngIf="fee.lateFeeType === 'one-time'">
											One-Time late fee of
											<span *ngIf="fee.oneTimeLateFeeType === 'flat'">
												{{fee.oneTimeLateFeeAmount | legfiCurrency:'USD':'symbol':'.2'}}
											</span>
											<span *ngIf="fee.oneTimeLateFeeType === 'interest-simple'">
												{{fee.oneTimeLateFeeAmount / 100}}% of the charge balance
											</span>
											<span *ngIf="fee.oneTimeLateFeeType === 'interest-compound'">
												{{fee.oneTimeLateFeeAmount / 100}}% of the charge balance plus fees
											</span>
											if paid later than
                                            {{fee.oneTimeLateFeeApplies | legfiDate:'MM/DD/YYYY'}}.
										</span>
                                    <span *ngIf="fee.lateFeeType === 'recurring'">
											Recurring late fee of
											<span *ngIf="fee.recurringLateFeeType === 'flat'">
												{{fee.recurringLateFeeAmount | legfiCurrency:'USD':'symbol':'.2'}}
											</span>
											<span *ngIf="fee.recurringLateFeeType === 'interest-simple'">
												{{fee.recurringLateFeeAmount / 100}}% of the charge balance
											</span>
											<span *ngIf="fee.recurringLateFeeType === 'interest-compound'">
												{{fee.recurringLateFeeAmount / 100}}% of the charge balance plus fees
											</span>
											beginning {{fee.recurringLateFeeBegins | legfiDate:'MM/DD/YYYY'}},
											repeating every
											<span *ngIf="fee.recurringLateFeeIntervalValue > 1">
												{{fee.recurringLateFeeIntervalValue}}
                                                {{fee.recurringLateFeeInterval}}.
											</span>
											<span *ngIf="fee.recurringLateFeeIntervalValue == 1">
												{{fee.recurringLateFeeInterval.slice(0, -1)}}.
											</span>
										</span>
                                </ng-template>
                            </div>

                        </td>
                        <td class="charge-unit" data-label="Unit">
                            {{charge.name}}
                        </td>
                        <td class="charge-date" data-label="Active On">
                            <span class="date-labels">Billed on: </span>{{charge.activeAfter | legfiDate:'MMM Do, YYYY'}}
                        </td>
                        <td class="charge-date" data-label="Due Date">
                            <span class="date-labels">Due Date: </span>{{charge.paymentDueOn | legfiDate:'MMM Do, YYYY'}}
                            <div *ngIf="charge.status === 'future'" class="charge-status future">Future</div>
                            <div *ngIf="charge.status === 'current'" class="charge-status current">Current</div>
                            <div *ngIf="charge.status === 'overdue'" class="charge-status overdue">Past&nbsp;Due</div>
                            <div *ngIf="charge.status === 'paid'" class="charge-status paid">Paid</div>
                            <div *ngIf="charge.status === 'partial'" class="charge-status partial">Partial</div>
                            <div *ngIf="charge.status === 'deleted'" class="charge-status deleted">Deleted</div>
                        </td>
                        <td class="payment-amount" data-label="Payment Amount">
                            <div class="range-slider-container">

                                <lf-currency
                                    (blurred)="modifyRowCheckedStatus(charge, charge.paymentAmount > 0); calculatePaymentsTotal()"
                                    [(ngModel)]="charge.paymentAmount"
                                    [showSymbol]="true"
                                    ngDefaultControl
                                    required
                                ></lf-currency>
                                <div class="of-value">
                                    <span> of </span>
                                    <span>{{charge.balance | legfiCurrency:'USD':'symbol':'.2'}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="hasLateFees" class="pb-2 text-right">
        <span *ngIf="doPayFeesFirst">* You must pay any fees in full with or before their originating charge.</span>
    </div>

    <div class="row">
        <div class="col-md-6 col-12">
            <div *ngIf="!isLoadingCharges && (charges && charges.length)" class="card">
                <div class="card-header">
                    <h2>Payment Information</h2>
                </div>
                <div class="card-body p-0">
                    <div class="fake-header">
                        <!-- version for user -->
                        <lf-payment-method-selector
                            #paymentMethodSelector
                            *ngIf="charges && charges.length && !hasOrgCharges"
                            (modelChange)="paymentMethodChanged($event)"
                            [doStackColumns]="true"
                            [model]="paymentMethod"
                            [isPaymentMethodNotSelected]="isPaymentMethodNotSelected"
                            ngDefaultControl>
                        </lf-payment-method-selector>
                        <!-- version for org -->
                        <lf-payment-method-selector
                            #paymentMethodSelector
                            *ngIf="charges && charges.length && hasOrgCharges"
                            (modelChange)="paymentMethodChanged($event)"
                            [doStackColumns]="true"
                            [model]="paymentMethod"
                            [orgCharges]="hasOrgCharges"
                            [organizationId]="jwt.orgId"
                            [isPaymentMethodNotSelected]="isPaymentMethodNotSelected"
                            ngDefaultControl>
                        </lf-payment-method-selector>
                    </div>
                </div>
            </div>

            <div class="card" *ngIf="!hasOrgCharges">
                <div class="card-body p-0">
                    <div class="d-flex w-100 px-4 py-3 justify-content-between">
                        <label class="mb-0">Auto-pay is
                            <span *ngIf="hasAutoPay" class="text-success">enabled</span>
                            <span *ngIf="!hasAutoPay" class="text-danger">disabled</span>
                        </label>
                        <a [attr.aria-label]="'toggle show autopay'" (click)="hasAutopayConfiguration = !hasAutopayConfiguration"
                           class="d-inline-block ml-1 text-primary font-weight-normal add-hover">
                            <small>
                                <ng-container *ngIf="!hasAutoPay">
                                    <span *ngIf="!hasAutopayConfiguration">enable autopay</span>
                                    <span *ngIf="hasAutopayConfiguration">hide details</span>
                                </ng-container>

                                <ng-container *ngIf="hasAutoPay">
                                    <span *ngIf="hasAutopayConfiguration">hide</span>
                                    <span *ngIf="!hasAutopayConfiguration">show</span> details
                                </ng-container>
                            </small>
                        </a>
                    </div>
                    <div class="fake-footer d-flex align-items-center">
                        <div class="d-inline-block auto-image">
                            <img src="/assets/images/payhoa/other/auto-pay_icon.svg">
                        </div>
                        <div class="d-inline-block ml-3">
                            <div class="easy">Bill Payment Made Easy, with Auto-Pay.</div>
                            <div class="ensure">Ensure your bills are paid. On time, every time!</div>
                        </div>
                    </div>
                    <div *ngIf="hasAutopayConfiguration">
                        <lf-autopay (enabled)="updateAutopayStatus()"
                                    [doAutoOpen]="true"></lf-autopay>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-12">
            <div class="card">
                <div class="card-header d-flex justify-content-between w-100">
                    <h2 class="pr-2">
                        Checkout
                    </h2>
                    <h2 class="mr-4"> Amount Due:
                        <strong
                            *ngIf="accountBalance !== null"
                            [innerHTML]="accountBalance | legfiCurrency:'USD':'symbol':'.2':true">
                        </strong>
                    </h2>
                </div>
                <div class="card-body p-0">
                    <table class="table">
                        <tr>
                            <td class="py-3">Selected Charges:
                            </td>
                            <td class="text-right">
                                <strong>{{paymentsSubtotal | legfiCurrency:'USD':'symbol':'.2'}}</strong>
                            </td>
                        </tr>

                        <tr *ngIf="paymentsTotal !== paymentsSubtotal">
                            <td class="py-3">+ Processing Fee:
                                <span *ngIf="organization && organization.rates.checkRateFlat === 0" class="processing-fee-notice">
                                To avoid processing fees, please change the method of payment.
                            </span>
                            </td>
                            <td class="text-right"><strong>{{(paymentsTotal - paymentsSubtotal) |
                                legfiCurrency:'USD':'symbol':'.2'}}</strong>
                            </td>
                        </tr>
                    </table>

                    <div class="fake-footer w-100 full-hide text-center">
                    <span class="lead">
                        <span class="text-muted">Total: </span> <span
                        class="font-weight-bold">{{paymentsTotal | legfiCurrency:'USD':'symbol':'.2'}}</span>
                    </span>

                        <br>

                        <button (click)="checkout();"
                                [disabled]="isButtonDisabled"
                                class="btn btn-primary btn-block mobile-submit">
                            Make a Payment of
                            <span>{{paymentsTotal | legfiCurrency:'USD':'symbol':'.2'}}</span>
                        </button>
                    </div>
                </div>
                <div class="align-items-center card-footer d-flex w-100 justify-content-between custom-hide">
                        <span class="lead">
                            <span class="text-muted">Total: </span> <span
                            class="font-weight-bold">{{paymentsTotal | legfiCurrency:'USD':'symbol':'.2'}}</span>
                        </span>

                    <button (click)="checkout();"
                            [disabled]="isButtonDisabled"
                            class="btn btn-primary px-3">
                        Make a Payment of
                        <span>{{paymentsTotal | legfiCurrency:'USD':'symbol':'.2'}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
